import { cn } from "@/utils/cn";

interface HoverCharProps {
  className?: string;
  isActive?: boolean;
  activeClassName?: string;
  char?: string;
}

export function HoverChar({
  className,
  isActive,
  activeClassName,
  char = ">",
}: HoverCharProps) {
  return (
    <span
      className={cn(
        "w-0 overflow-hidden opacity-0 transition-all duration-300",
        isActive ? activeClassName : className,
      )}
    >
      {char}
    </span>
  );
}
